import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material';

export const CircularProgress = MuiCircularProgress;
export type CircularProgressProps = MuiCircularProgressProps;
